export default function MockGamificacao() {
  return (
    <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-50">
      <div className="aspect-[3/2] w-full">
        <img
          src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/2bb17a06373d6be76fce7178b9018e91.png"
          alt="Ranking de campanha, progresso do participante, missões diárias e conquistas em app"
          title="Gamificação e ranking de campanha de incentivo"
          className="h-full w-full object-contain"
        />
      </div>
    </div>
  );
}